import { enableMapSet, enableES5 } from "immer";

enableMapSet();
enableES5();
